import React from 'react';

export default function WarningFullIcon({ width = 18, height = 15, fill = '#EB3D3D' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 14.75H17.25L9 0.5L0.75 14.75ZM9.75 12.5H8.25V11H9.75V12.5ZM9.75 9.5H8.25V6.5H9.75V9.5Z" fill={fill}/>
    </svg>
  );
}
